(function () {

  // Lock the card's animation via inline style so the base CSS `fph-card-fadein`
  // rule cannot restart when modifier classes (fph--fading / fph--entering) are removed.
  function lockCard(card) {
    card.style.animation = 'none';
  }

  // Unlock inline lock, then immediately apply a modifier class in the same
  // microtask so the browser never renders an intermediate fph-card-fadein frame.
  function unlockAndEnter(card) {
    card.style.animation = '';
    card.classList.add('fph--entering');
    setTimeout(function () {
      card.classList.remove('fph--entering');
      lockCard(card);
    }, 400);
  }

  function fadeCard(card, callback) {
    // Unlock inline lock and switch to fading — both happen in the same microtask
    // so the browser never renders fph-card-fadein between the two states.
    card.style.animation = '';
    card.classList.remove('fph--entering');
    card.classList.add('fph--fading');

    setTimeout(function () {
      callback();
      // Remove fading and add entering in the same microtask (no offsetHeight
      // reflow between them) so fph-card-fadein never gets a rendered frame.
      card.classList.remove('fph--fading');
      card.classList.add('fph--entering');
      setTimeout(function () {
        card.classList.remove('fph--entering');
        lockCard(card);
      }, 400);
    }, 150);
  }

  function burstHotspot(btn) {
    btn.classList.remove('fph-hotspot--burst');
    void btn.offsetHeight;
    btn.classList.add('fph-hotspot--burst');
    setTimeout(function () { btn.classList.remove('fph-hotspot--burst'); }, 450);
  }

  function initHotspots(wrapper) {
    wrapper.querySelectorAll('.fph-slide').forEach(function (slide) {
      var hotspots = Array.from(slide.querySelectorAll('.fph-hotspot'));
      if (!hotspots.length) return;

      var card = slide.querySelector('.fph-card');
      if (!card) return;

      var titleEl  = card.querySelector('.fph-card-title');
      var priceEl  = card.querySelector('.fph-card-price');
      var btnEl    = card.querySelector('.fph-card-btn');
      var imgEl    = card.querySelector('.fph-card-image img');
      var imgWrap  = card.querySelector('.fph-card-image');

      // Read original state from data attributes baked in by Liquid so that
      // the product image override is always restored correctly on revert.
      var d = card.dataset;
      var orig = {
        title:    d.origTitle   || (titleEl ? titleEl.textContent       : ''),
        price:    d.origPrice   || (priceEl ? priceEl.textContent       : ''),
        btnHref:  d.origUrl     || (btnEl   ? btnEl.getAttribute('href'): ''),
        imgSrc:   d.origImgSrc  || (imgEl   ? imgEl.getAttribute('src') : ''),
        imgAlt:   d.origImgAlt  || (imgEl   ? imgEl.getAttribute('alt') : ''),
        imgW:     d.origImgWidth  || (imgEl ? imgEl.getAttribute('width')  : ''),
        imgH:     d.origImgHeight || (imgEl ? imgEl.getAttribute('height') : ''),
        hasImg:   !!imgWrap,
        imgShown: !!d.origImgSrc || (imgWrap ? imgWrap.style.display !== 'none' : false),
      };

      var activeBtn = hotspots[0];

      hotspots.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (activeBtn === btn) return;
          burstHotspot(btn);
          if (activeBtn) activeBtn.classList.remove('fph-hotspot--active');
          btn.classList.add('fph-hotspot--active');
          activeBtn = btn;
          if (btn === hotspots[0]) {
            fadeCard(card, function () { applyState(orig, true); });
          } else {
            fadeCard(card, function () { applyHotspot(btn); });
          }
        });
      });

      slide._fphReset = function () {
        hotspots.forEach(function (b) { b.classList.remove('fph-hotspot--active'); });
        if (hotspots[0]) hotspots[0].classList.add('fph-hotspot--active');
        activeBtn = hotspots[0] || null;
        applyState(orig, true);
      };

      function applyHotspot(btn) {
        var d = btn.dataset;
        if (titleEl && d.title) titleEl.textContent = d.title;
        if (priceEl && d.price) priceEl.textContent = d.price;
        if (btnEl   && d.url)   btnEl.setAttribute('href', d.url);
        if (imgWrap) {
          if (d.imgSrc) {
            imgWrap.style.display = '';
            if (!imgEl) {
              imgEl = document.createElement('img');
              imgEl.loading = 'lazy';
              imgWrap.appendChild(imgEl);
            }
            imgEl.src = d.imgSrc;
            imgEl.alt = d.imgAlt || '';
            if (d.imgWidth)  imgEl.width  = d.imgWidth;
            if (d.imgHeight) imgEl.height = d.imgHeight;
          } else {
            imgWrap.style.display = 'none';
          }
        }
      }

      function applyState(state, isOrig) {
        if (titleEl) titleEl.textContent = state.title;
        if (priceEl) priceEl.textContent = state.price;
        if (btnEl)   btnEl.setAttribute('href', state.btnHref);
        if (imgWrap && isOrig) {
          imgWrap.style.display = state.imgShown ? '' : 'none';
          if (imgEl && state.imgSrc) {
            imgEl.src             = state.imgSrc;
            imgEl.alt             = state.imgAlt;
            if (state.imgW) imgEl.width  = state.imgW;
            if (state.imgH) imgEl.height = state.imgH;
          }
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('.fph-wrapper[data-count]').forEach(function (el) {
      if (el.dataset.fphInit) return;
      el.dataset.fphInit = 'true';

      initHotspots(el);

      // Lock cards after fph-card-fadein (0.5s) completes so the base CSS
      // animation cannot replay when modifier classes are later removed.
      setTimeout(function () {
        el.querySelectorAll('.fph-card').forEach(lockCard);
      }, 600);

      var count = parseInt(el.dataset.count, 10);
      if (count <= 1) return;

      var showDots   = el.dataset.showDots === 'true';
      var autoHeight = el.dataset.autoHeight === 'true';

      el.classList.add('splide');
      var track = el.querySelector('.fph-track');
      var list  = el.querySelector('.fph-list');
      if (track) track.classList.add('splide__track');
      if (list)  list.classList.add('splide__list');
      el.querySelectorAll('.fph-slide').forEach(function (slide) {
        slide.classList.add('splide__slide');
      });

      var splide = new Splide(el, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: showDots,
        autoplay: false,
        autoHeight: autoHeight,
      });

      splide.on('moved', function () {
        var activeSlide = el.querySelector('.splide__slide.is-active');
        if (activeSlide) {
          var card = activeSlide.querySelector('.fph-card');
          if (card) {
            // Lock first so the reflow cannot start fph-card-fadein, then
            // reset animation state, then unlock + enter in the same microtask.
            lockCard(card);
            card.classList.remove('fph--entering');
            void card.offsetHeight;
            unlockAndEnter(card);
          }
          if (typeof activeSlide._fphReset === 'function') {
            activeSlide._fphReset();
          } else {
            activeSlide.querySelectorAll('.fph-hotspot--active').forEach(function (btn) {
              btn.classList.remove('fph-hotspot--active');
            });
          }
        }
      });

      splide.mount();

      var prevBtn = el.querySelector('.fph-arrow--prev');
      var nextBtn = el.querySelector('.fph-arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
